<template>
    <div>
        <el-form ref="form" label-position="top" :model="declaration" label-width="80px"> 
            <formTitle title="聲明 Declaration"></formTitle>
             <div class="declaration-text">
                此表格所收集的個人資料只用作本校入學申請之用。根據《個人資料(私隱)條例》第18和22條及附表1第6原則的規定,家長或監護人有權查閱及改正個人資料。
             </div>
             <div>
               The personal data collected in this form will only be used for the purpose of admission application. You have a right to access and alter your personal data as provided for in Section 18 and 22 and Principle 6 of Schedule 1of the Personal Data (Privacy) Ordinance.
             </div>
            <el-row :gutter="20" type="flex" class="declaration-text">
                <el-col :span="3" style="text-align: right;"> <el-checkbox v-model="declaration.isReadStatement"></el-checkbox> 
                </el-col>
                <el-col :span="20"> 
                    <div class="checkbox-text">本人已細閱以上各項聲明及明白內容。如有任何爭議,本校擁有最終決定權。</div>
                    <div class="checkbox-text">I have read the above statements and content carefully. If there is any dispute, the school has the right to the final decision. </div>
                </el-col>
            </el-row>
     
            <el-form-item v-if="!isView && !adminEdit" class="from-button-group" label="" style="text-align: center;">
                <el-button  type="success" @click="onBack">
                    返回 Back
                                    </el-button>
                <el-button :class="{'checkedPrimary':!declaration.isReadStatement}" :disabled="!declaration.isReadStatement"  type="primary" @click="onSave">
                    儲存 Save
                                    </el-button>
                <el-button :class="{'checkedPrimary':!declaration.isReadStatement}" :disabled="!declaration.isReadStatement"  type="primary" @click="onSaveAndContinue">
                    下一頁 Next
                                    </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import formTitle from '@/components/formTitle'
    export default {
    components:{formTitle},
    props:{
        declaration:{
            type:Object,
            default:function(){}
        },
        isView:{
            type:Boolean,
            default:false
        },
        adminEdit:{
            type:Boolean,
            default:false
        }
       
    },
    data() {
      return {
        
      }
    },
    methods: {
        onBack(){
            this.$emit('personalBackgroundBack')
        },
        onSave(){
            this.$emit('personalBackgroundSave')
        },
        onSaveAndContinue(){
            this.$emit('personalBackgroundSaveAndContinue')
        },
    }
    }
</script>

<style lang="scss" scoped>
.document-identity-radio{
    display: flex;
    flex-direction: column;
}
.document-identity-radio .el-radio{
    display: flex;
    margin-bottom: 20px;
}
.el-button--primary{
    width: auto;
}
.row-list{
    padding: 30px 0;
    border-bottom: 1px solid #E5E5E5;
}
.from-button-group{
    margin-top: 30px;
}
.declaration-text{
    margin-top: 30px;
}
.checkedPrimary{
    background-color: #AAAAAA;
    border-color: #AAAAAA;
}
::v-deep{
    .el-input__inner{
        border-color: #72ACFF;
        border: 3px solid #0062ff;
    }
    .el-date-editor.el-input{
        width: 100%;
    }
    .el-button--primary.is-disabled:hover{
        background-color: #AAAAAA;
        border-color: #AAAAAA;
    }
    .el-checkbox__inner{
    width: 2rem;
    height: 2rem;
    border: 3px solid #0062ff;
    margin-top: 0.3125rem;
  }
  .el-checkbox__inner::after{
        left: 0.7375rem;
        top: 0.25rem;
        height: 0.9375rem;
    }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .from-button-group .el-button{
    margin-bottom: 0.625rem;
  }
  .from-button-group .el-button:last-child{
    margin-left: 0;
  }
}
</style>